import type { RelatedContactSummary } from '@common/types/contacts';
import { Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import DataTable, { type Column } from '@/components/DataTable';
import ProspectCellLink from '../ProspectCellLink';

interface Props {
    relatedContacts: RelatedContactSummary[];
}

const columns: Column<RelatedContactSummary>[] = [
    {
        id: 'contactName',
        label: 'Name',
        _render: (contact) => (
            <Link style={{ fontWeight: 500 }} to={`/contacts/${contact.contactId}`}>
                {contact.contactName}
            </Link>
        ),
    },
    {
        id: 'prospect',
        label: 'Prospect',
        _render: (contact) => (
            <ProspectCellLink
                prospectId={contact.prospect.prospectId}
                prospectName={contact.prospect.prospectName}
                customFileNumber={contact.prospect.customFileNumber}
            />
        ),
    },
    {
        id: 'contactEmail',
        label: 'Email',
    },
    {
        id: 'phoneNumber',
        label: 'Phone',
        _render: (contact) => contact.phoneNumber ?? '',
    },
];

export default function RelatedContactsSection({ relatedContacts }: Props) {
    return (
        <Stack
            spacing={2}
            p={3}
            sx={{
                border: '1px solid',
                borderColor: 'neutral.borderColor',
                borderRadius: '4px',
                backgroundColor: 'neutral.white',
            }}
        >
            <Typography variant="h3">Related Contacts</Typography>
            {relatedContacts.length === 0 ? (
                <Typography variant="body2" color="text.secondary">
                    No other contacts on this matter.
                </Typography>
            ) : (
                <DataTable
                    generateKeyFrom="contactId"
                    columns={columns}
                    rows={relatedContacts}
                    page={0}
                    rowsPerPage={Math.max(relatedContacts.length, 5)}
                    handleChangePage={() => undefined}
                    handleChangeRowsPerPage={() => undefined}
                />
            )}
        </Stack>
    );
}
